var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51852 9.78565C3.90142 12.8602 6.13495 14.8412 8.64281 16.9307C9.38641 17.5503 10.4719 17.5517 11.2012 16.9154C13.7759 14.6688 16.2191 12.1573 17.6074 9.07137C18.2201 7.70954 18.1045 5.66764 17.3389 4.38531C16.7034 3.32108 15.33 2.85316 14.1061 3.04025C12.8823 3.22735 11.8173 3.96553 10.9466 4.8474C10.5808 5.21795 9.92873 6.21426 9.92873 6.5714C9.92873 6.21426 9.29025 5.21795 8.92442 4.8474C8.0537 3.96553 6.97477 3.22735 5.75095 3.04025C4.52714 2.85316 3.15408 3.32108 2.51852 4.38531C1.753 5.66764 1.90552 8.42382 2.51852 9.78565Z",
    fill: "current",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.e679577a3335ad3499a365516c5ea6e8.svg";
export { ForwardRef as ReactComponent };